"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnologyPreview = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const docs_links_1 = require("../../config/docs_links");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const PreviewBadge_1 = require("./PreviewBadge");
const TechnologyPreview = (props) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(PreviewBadge_1.PreviewBadge, Object.assign({ text: t('ai:Technology Preview'), popoverContent: t('ai:Technology preview features provide early access to upcoming product innovations, enabling you to test functionality and provide feedback during the development process.'), externalLink: docs_links_1.TECH_SUPPORT_LEVEL_LINK }, props)));
};
exports.TechnologyPreview = TechnologyPreview;
exports.TechnologyPreview.displayName = 'TechnologyPreview';
//# sourceMappingURL=TechnologyPreview.js.map